import http, { getEnvironment, getManagerUrl, getAuthUrl, getSiteCode } from './network';

export const getUsername = (username, sitecode) => {
	const code = sitecode.split('@')[0];
	return `${username}@${ code }`;
};

const login = (username, password, sitecode) => {
	const environment = getEnvironment(sitecode);
	const url = `${ getAuthUrl(environment) }/connect/token`;
	const user = getUsername(username, sitecode);
	const formData = {
		grant_type: 'password',
		client_id: 'WebGLClient',
		// client_id: 'auth.tests',
		client_secret: 'xM56!@u2^ZX$',
		username: user,
		password
	};

	return http.post(url, 'form', formData);
};

const loginWithToken = (encryptedtoken, signature, sitecode) => {
	const environment = getEnvironment(sitecode);
	const url = `${ getAuthUrl(environment) }/connect/token`;
	const formData = {
		grant_type: 'ssotoken',
		client_id: 'WebGLClient',
		encryptedtoken,
		signature
	};

	return http.post(url, 'form', formData);
};

const redeemOneTimeToken = (token, redirectUri, environment) => {
	const url = `${ getAuthUrl(environment) }/connect/token`;
	const formData = {
		grant_type: 'ott',
		client_id: 'WebGLClient',
		ott: token,
		redirect_uri: redirectUri
	};

	return http.post(url, 'form', formData);
}

const validateSiteCode = (sitecode) => {
	const baseSitecode = getSiteCode(sitecode);
	const environment = getEnvironment(sitecode);
	const url = `${ getManagerUrl(environment) }/v0.9/authenticationSiteCodes/` + baseSitecode;
	return http.get(url);
};

const student = (studentId, sitecode, accessToken) => {
	const environment = getEnvironment(sitecode);
	const url = `${ getManagerUrl(environment) }/v2.2/students/` + studentId + `?additionalfields=products`;
	return http.getWithAuth(url, accessToken);
};

// Define the service
const Auth = {
	login,
	loginWithToken,
	validateSiteCode,
	redeemOneTimeToken,
	student
};

export default Auth;



// WEBPACK FOOTER //
// ./src/services/auth.service.js